module.exports = __webpack_public_path__ + "img/kyz.f0ca65b7.png";